import { gConsts } from '@/globals/gConsts';
import LabelAnnotation from '../../models/LabelAnnotation';

export default class LabelAnnotationValidator {

    /**
     * @param {LabelAnnotation} labelAnnotation 
     */
    static run(labelAnnotation) {
        if (!labelAnnotation)
            return false;

        if ([gConsts.node.report.annotation.types.RTOOTH,
        gConsts.node.report.annotation.types.TOOTH].includes(labelAnnotation.tipo)) {
            return labelAnnotation.localizacao?.dentes?.length > 0;
        }

        if ([gConsts.node.report.annotation.types.ANAT_RTOOTH].includes(labelAnnotation.tipo)) {
            return labelAnnotation.localizacao?.regioesAnatomicas?.length > 0;
        }

        if ([gConsts.node.report.annotation.types.PROX_ANAT_RTOOTH].includes(labelAnnotation.tipo)) {
            return labelAnnotation.localizacao?.regioesAnatomicas?.length > 0 ||
                labelAnnotation.localizacao?.dentes?.length > 0;
        }

        return true;
    }

}